import React from 'react';

import { BrowserRouter, Route, Switch } from 'react-router-dom';

import NotFound from './NotFound';
import configs from './configs';
import { cleanLoadTexture } from './utils/textureHelper';
import Search from './containers/Search';
// import World from './containers/world';
import { Layout } from 'components/Layout';
import LienKetVungPage from 'pages/LienKetVung';
import TienIchPage from 'pages/TienIch';
import MatBangTangPage from 'pages/MatBangTang';
import CanHoMauPage from 'pages/CanHoMau';
import { WorldFC } from 'components/World';
import TongQuanPage from 'pages/TongQuan';

window.defaultTexture = null;
cleanLoadTexture(configs.baseUrl + '/assets/images/white-square.png').then(
  (texture) => {
    window.defaultTexture = texture;
  }
);

function AppRoutes() {
  return (
    <BrowserRouter>
      <Layout>
        {(configs.singleTour && (
          <Switch>
            <Route
              exact
              path="/not-found"
              render={(props) => <NotFound {...props} />}
            />
            <Route
              path="/:sceneId/:hotspotId"
              render={(props) => <WorldFC {...props} />}
            />
            <Route
              path="/:sceneId"
              render={(props) => <WorldFC {...props} />}
            />
            <Route path="/" render={(props) => <WorldFC {...props} />} />
            <Route path="*" render={(props) => <NotFound {...props} />} />
          </Switch>
        )) || (
            <Switch>
              <Route
                exact
                path="/not-found"
                render={(props) => <NotFound {...props} />}
              />
              <Route
                path="/vi-tri"
                render={(props) => <LienKetVungPage {...props} />}
              />
              <Route
                path="/tien-ich"
                render={(props) => <TienIchPage {...props} />}
              />
              <Route
                path="/mat-bang-tang"
                render={(props) => <MatBangTangPage {...props} />}
              />
              <Route
                path="/can-ho-mau/:slug*"
                render={(props) => <CanHoMauPage {...props} />}
              />
              <Route
                path="/tong-quan/:slug*"
                render={(props) => <TongQuanPage {...props} />}
              />
              {/* <Route
              path="/:tourId/can-ho-mau"
              render={(props) => <CanHoMauPage {...props} />}
            /> */}

              {/* <Route
              path="/:tourId/:groupId/:sceneId/:hotspotId"
              render={(props) => {
                console.log('World props with hotspotId', props);
                return <WorldFC {...props} />;
              }}
            />
            <Route
              path="/:tourId/:groupId/:sceneId"
              render={(props) => {
                console.log('World props with sceneId', props);
                return <WorldFC {...props} />;
              }}
            />
            <Route
              path="/:tourId/:groupId"
              render={(props) => <WorldFC {...props} />}
            />
            <Route path="/:tourId" render={(props) => <WorldFC {...props} />} /> */}
              <Route path="/" render={(props) => <Search {...props} />} />
              <Route path="*" render={(props) => <NotFound {...props} />} />
            </Switch>
          )}
      </Layout>
    </BrowserRouter>
  );
}

export default AppRoutes;
